import {VISIBLE} from './types';

export const visible = () => dispatch => {
    dispatch({
        type: VISIBLE
    });
}


